import { ref, computed } from 'vue'

type AuthLevel = 'full' | 'trial'

const HARDCODED_PASSWORDS = ['p250711740', 'p260712048']
const TRIAL_PASSWORD = 'p260412041'
const isAuthenticated = ref(false)
const hasVisitedTerms = ref(false)
const authLevel = ref<AuthLevel | null>(null)

export const useAuth = () => {
  const login = (password: string): boolean => {
    if (HARDCODED_PASSWORDS.includes(password)) {
      isAuthenticated.value = true
      authLevel.value = 'full'
      localStorage.setItem('auth', 'true')
      localStorage.setItem('authLevel', 'full')
      return true
    }
    if (password === TRIAL_PASSWORD) {
      isAuthenticated.value = true
      authLevel.value = 'trial'
      localStorage.setItem('auth', 'true')
      localStorage.setItem('authLevel', 'trial')
      return true
    }
    return false
  }

  const logout = () => {
    isAuthenticated.value = false
    authLevel.value = null
    localStorage.removeItem('auth')
    localStorage.removeItem('authLevel')
    resetTermsVisited()
  }

  const checkAuth = () => {
    const auth = localStorage.getItem('auth')
    const level = localStorage.getItem('authLevel') as AuthLevel | null
    isAuthenticated.value = auth === 'true'
    authLevel.value = level
    return isAuthenticated.value
  }

  const getAuthLevel = (): AuthLevel | null => {
    return authLevel.value
  }

  const markTermsAsVisited = () => {
    hasVisitedTerms.value = true
    localStorage.setItem('termsVisited', 'true')
  }

  const checkTermsVisited = () => {
    const visited = localStorage.getItem('termsVisited')
    hasVisitedTerms.value = visited === 'true'
    return hasVisitedTerms.value
  }

  const resetTermsVisited = () => {
    hasVisitedTerms.value = false
    localStorage.removeItem('termsVisited')
  }

  return {
    isAuthenticated: computed(() => isAuthenticated.value),
    hasVisitedTerms: computed(() => hasVisitedTerms.value),
    login,
    logout,
    checkAuth,
    getAuthLevel,
    markTermsAsVisited,
    checkTermsVisited,
    resetTermsVisited
  }
}